<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>平台管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :show-header="false">
      <el-form @submit.native.prevent="addHotTag()">
        <el-tag :key="index"
                v-for="(tag,index) in dynamicTags"
                closable
                :disable-transitions="false"
                @close="handleClose(tag.id)">{{tag.name}}
        </el-tag>
        <br><br/>
        <template v-permission="29">
          <el-col :span="4">
            <el-input v-model="form.name"
                      placeholder="请输入内容"></el-input>
          </el-col>
          <el-col :offset="1"
                  :span="2">
            <el-button type="primary"
                       native-type="submit">添加
            </el-button>
          </el-col>
        </template>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dynamicTags: [],
      form: {
        name: null,
      },
    }
  },
  computed: Vuex.mapState({}),
  created () {
    this.getHotTag()
  },
  methods: {
    ...Vuex.mapActions(['getHotTag', 'deleteHotTag', 'addHotTag']),
    getHotTag () {
      return request.page('getHotTag').then((res) => {
        this.dynamicTags = []
        for (let i = 0; i < res.data.data.length; i++) {
          this.dynamicTags.push(res.data.data[i])
        }
      })
    },
    handleClose (tagId) {
      return request.common('deleteHotTag', tagId).then((res) => {
        this.getHotTag()
      })
    },
    addHotTag () {
      if (this.dynamicTags.length >= 20) {
        this.$message({
          showClose: true,
          message: '热搜标签数量已经大于等于20个，无法添加',
          type: 'error',
        })
        return false
      }
      if (!this.form.name || this.form.name.length <= 0) {
        this.$message({
          showClose: true,
          message: '请输入标签名称',
          type: 'error',
        })
        return false
      }
      for (let i = 0; i < this.dynamicTags.length; i++) {
        if (this.form.name === this.dynamicTags[i].name) {
          this.$message({
            showClose: true,
            message: '不能添加重复的标签',
            type: 'error',
          })
          return false
        }
      }
      return request.common('addHotTag', this.form).then((res) => {
        this.form.name = ''
        this.getHotTag()
      })
    },

  },
}
</script>
<style>
.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/views/platform/pages/PlatformTagTable.vue